// extracted by mini-css-extract-plugin
export var body = "_kz-0";
export var sectionHeader = "_kz-4";
export var shortcutColumns = "_kz-2";
export var shortcutList = "_kz-1";
export var shortcutSection = "_kz-3";